export default "__VITE_ASSET__2yJWPsgT__"